const firebaseConfig = {

    apiKey: "AIzaSyAhm4XScpm0SY-kOn14VHZx_XGc7ZHLYEQ",
  
    authDomain: "tourist-service-app.firebaseapp.com",
  
    projectId: "tourist-service-app",
  
    storageBucket: "tourist-service-app.appspot.com",
  
    messagingSenderId: "257567801965",
  
    appId: "1:257567801965:web:8005630979ee487b0cf564"
  
  };
export default firebaseConfig; 